module.exports = __webpack_public_path__ + "static/media/fb.08abfa14.svg";